import api from './api';

const BASE = '/notifications';

const notificationService = {

  getStats: async () => {
    const { data } = await api.get(`${BASE}/stats`);
    return data;
  },

  getTemplates: async (module, search) => {
    const params = {};
    if (module) params.module = module;
    if (search) params.search = search;
    const { data } = await api.get(`${BASE}/templates`, { params });
    return data;
  },

  getTemplate: async (id) => {
    const { data } = await api.get(`${BASE}/templates/${id}`);
    return data;
  },

  createTemplate: async (payload) => {
    const { data } = await api.post(`${BASE}/templates`, payload);
    return data;
  },

  updateTemplate: async (id, payload) => {
    const { data } = await api.put(`${BASE}/templates/${id}`, payload);
    return data;
  },

  revertTemplate: async (id) => {
    const { data } = await api.post(`${BASE}/templates/${id}/revert`);
    return data;
  },

  toggleActive: async (id, active) => {
    const { data } = await api.patch(`${BASE}/templates/${id}/active`, { active });
    return data;
  },

  deleteTemplate: async (id) => {
    await api.delete(`${BASE}/templates/${id}`);
  },
};

export default notificationService;